howspace.components.wordcloud = (() => {
    'use strict';

    real.events.on('ai:wordcloud:widget:completed', notification => {
        if (notification.object.target_widget) {
            // Handle target widget.
            const widget = $('#widget-' + notification.object.target_widget.id);
            if (widget.length > 0) {
                howspace.aiGen.clearPromptTimeout(widget);
                const wordCloud = widget.find('.howspace-wordcloud');
                if (wordCloud.length > 0) {
                    howspace.components.wordcloud.update(wordCloud, notification.object.items);
                }
            }
        } else if (notification.object.process_id) {
            // Handle dedicated AI process.
            const modal = $('.ai-full-screen-modal[data-process-id="' + notification.object.process_id + '"]');
            if (modal.length > 0) {
                howspace.components.wordcloud.update(modal.find('.howspace-wordcloud'), notification.object.items);
                real.button.reset(modal.find('.ai-save-as-widget'));
            }
        }
    });

    real.events.on('ai:wordcloud:widget:failed', notification => {
        if (notification.object.target_widget) {
            // Handle target widget.
            const widget = $('#widget-' + notification.object.target_widget.id);
            if (widget.length > 0) {
                howspace.aiGen.clearPromptTimeout(widget);
                const wordCloud = widget.find('.howspace-wordcloud');
                if (wordCloud.length > 0) {
                    howspace.components.wordcloud.update(wordCloud, notification.object.error, true);
                }
            }
        } else if (notification.object.process_id) {
            // Handle dedicated AI process.
            const modal = $('.ai-full-screen-modal[data-process-id="' + notification.object.process_id + '"]');
            if (modal.length > 0) {
                howspace.components.wordcloud.update(modal.find('.howspace-wordcloud'), notification.object.error, true);
                real.button.loading(modal.find('.ai-save-as-widget'));
            }
        }
    });

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            checkRedrawTimeout(entry.target);
        }
    });

    const checkRedrawTimeout = (cloud) => {
        cloud = $(cloud);

        if (cloud.data('redraw-timeout-id') !== undefined) {
            clearTimeout(cloud.data('redraw-timeout-id'));
        }

        cloud.data('redraw-timeout-id', setTimeout(() => {
            cloud.removeData('redraw-timeout-id');
            const latestWidth = cloud.data('latest-width');
            const latestHeight = cloud.data('latest-height');
            const currentWidth = cloud.width();
            const currentHeight = cloud.height();
            if (latestWidth !== currentWidth || latestHeight !== currentHeight) {
                // If the width or height has changed, redraw the word cloud.
                redrawWordCloud(cloud.closest('.howspace-wordcloud-initialized'));
            }
        }, 300));
    };

    // Redraw the word cloud with the given items [{text: string, count: number}].
    const redrawWordCloud = async function (wordCloud) {
        const items = wordCloud.data('items') || [];
        if (items.length === 0) {
            // No words, cannot draw anything.
            return;
        }

        const maxCount = getMaxCount(items);

        // Ensure the font is loaded, then start the layout.
        function startWhenFontIsReady(layout) {
            const font = new FontFace('GT Walsheim LC Bold', `url(${real.dom.$html.data('cdn-uri')}/assets/fonts/GT-Walsheim-LC-Bold.woff)`);
            font.load().then(function (loadedFont) {
                document.fonts.add(loadedFont);
                layout.start();
            });
        }

        await lib('d3', 'd3.min.js');
        await lib('d3-cloud', 'd3.layout.cloud.js');

        const cloud = wordCloud.find('.wordcloud-cloud');
        if (cloud.find('svg').length > 0) {
            // Add class name to use different animation when updating the words.
            wordCloud.addClass('update-words');
        }

        cloud.empty();

        const layout = d3.layout.cloud()
            .size([
                cloud.outerWidth(),
                calculateHeightWithMaxWordWidth(wordCloud, items, maxCount)
            ])
            .words(items.map(function (item) {
                return {
                    text: item.text,
                    count: item.count,
                    size: calculateItemFontSize(cloud.outerWidth(), maxCount, item.count),
                    color: calculateItemColor(item, items),
                    summary: item.keyphrase_summary || null,
                };
            }))
            .padding(calculatePadding(wordCloud.outerWidth(), maxCount))
            .random(function () {
                return 0.5  // Do not randomize the word placement.
            })
            .rotate(0) // Do not rotate the words.
            .font("'GT Walsheim LC Bold', sans-serif")
            .fontSize(function (d) {
                return d.size;
            })
            .spiral("archimedean")
            .on("end", draw);

        startWhenFontIsReady(layout);

        const enableSummaries = wordCloud.closest('.modal').length === 0;
        function draw(words) {
            d3.select(cloud[0]).append("svg")
                .attr("width", layout.size()[0])
                .attr("height", layout.size()[1])
                .append("g")
                .attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
                .selectAll("text")
                .data(words)
                .enter().append("text")
                .style("font-size", function (d) {
                    return d.size + "px";
                })
                .style("font-family", "'GT Walsheim LC Bold', sans-serif")
                .style("fill", function (d) {
                    return d.color;
                })
                .attr("text-anchor", "middle")
                .attr("transform", function (d) {
                    return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
                })
                .attr("data-summary", function (d) {
                    if (!enableSummaries) {
                        return null;
                    }
                    return d.summary || null;
                })
                .text(function (d) {
                    return d.text;
                });

            if (!cloud.hasClass('observing-resize')) {
                cloud.addClass('observing-resize');
                resizeObserver.observe(cloud[0]);
            }

            cloud.dataAndAttr('latest-width', cloud.width());
            cloud.dataAndAttr('latest-height', cloud.height());

            animateWords(wordCloud, cloud);

        }
    }

    const redrawWordCloudAsTranslatorCallback = wordCloud => {
        wordCloud.removeClass('translated');
        howspace.components.translator.setCallback(
            wordCloud.data('t9n-type'),
            wordCloud.data('t9n-id'),
            wordCloud.data('t9n-attr'),
            () => {
                let items = wordCloud.data('items');
                if (typeof items === 'string') {
                    items = JSON.parse(items);
                }
                wordCloud.dataAndAttr('items', items);
                wordCloud.find('.howspace-loader').hide();
                wordCloud.find('.wordcloud-no-content').hide();
                wordCloud.find('.wordcloud-content').show();
                redrawWordCloud(wordCloud);
            }
        );
    };

    // Get the highest count from the array of items.
    const getMaxCount = items => {
        if (!items || items.length === 0) {
            return 0;
        }
        return Math.max(...items.map(item => item.count || 1));
    }

    // Calculate the minimum and maximum font size based on the width of the word cloud.
    function calculateFontMinMax(width) {
        const minFontSize = Math.floor(width * 0.02); // 2% of width
        const maxFontSize = Math.floor(width * 0.075); // 7.5% of width
        return {minFontSize, maxFontSize};
    }

    // Calculate the font size based on the word count.
    const calculateItemFontSize = (width, highestWordCount, wordCount) => {
        const {minFontSize, maxFontSize} = calculateFontMinMax(width);
        const fontSizeMultiplyFactor = (maxFontSize - minFontSize) / Math.max(highestWordCount - 1, 1);
        return Math.max(7, minFontSize + fontSizeMultiplyFactor * (wordCount - 1)); // Ensure a minimum font size of 7
    };

    /**
     * Determine the color for each word based on its count relative to the top 20% of all items.
     * Find the item that's exactly at the top 20% of the list and use its count as a threshold.
     * Color the word with primary color if its count is greater than or equal to the top 20% count
     * and greater than the lowest count in the list (otherwise all words could be primary).
     */
    const calculateItemColor = (thisItem, allItems) => {
        const TOP_PERCENTAGE = 0.20;
        if (!allItems || allItems.length === 0) {
            return 'var(--howspace-color-widget-text)'; // Default color if no items are present.
        }
        const topRangeIndex = Math.ceil(allItems.length * TOP_PERCENTAGE) - 1; // Get the index for the top percentage.
        const topRangeCount = allItems[topRangeIndex].count || 1; // Get the count of the top item in the range.
        const lowestCount = allItems[allItems.length - 1].count || 1; // Get the count of the lowest item.
        // If the current item's count is greater than or equal to the top range count and greater than the lowest count, return primary color.
        if (thisItem.count >= topRangeCount && thisItem.count > lowestCount) {
            return 'var(--howspace-color-primary)';
        }
        // Otherwise, return the secondary color.
        return 'var(--howspace-color-widget-text)';
    }

    // Calculate the padding for the word cloud based on the width and highest word count.
    const calculatePadding = (width, highestWordCount) => {
        const {minFontSize, maxFontSize} = calculateFontMinMax(width);
        const fontSizeMultiplyFactor = (maxFontSize - minFontSize) / Math.max(highestWordCount - 1, 1);
        const actualMaxFontSize = minFontSize + fontSizeMultiplyFactor * (highestWordCount - 1);

        let padding = actualMaxFontSize * 0.025 - 0.7;
        padding = Math.max(-0.5, padding);
        padding = Math.min(3, padding);

        return padding;
    };

    // Calculate the height of the word cloud based on the word cloud width and the longest word.
    const calculateHeightWithMaxWordWidth = (wordCloud, words, highestWordCount) => {
        const width = wordCloud.outerWidth();
        const context = document.createElement('canvas').getContext('2d');

        // Calculate font size range.
        const {minFontSize, maxFontSize} = calculateFontMinMax(width);
        let fontSizeMultiplyFactor = (maxFontSize - minFontSize) / Math.max(highestWordCount - 1, 1);

        // Measure the longest word width.
        let maxWordWidth = 0;
        words.forEach(word => {
            const fontSize = minFontSize + fontSizeMultiplyFactor * (word.count - 1);
            context.font = `${fontSize}px 'GT Walsheim LC Bold', sans-serif`;
            const wordWidth = context.measureText(word.text).width;
            maxWordWidth = Math.max(maxWordWidth, wordWidth);
        });

        // Ensure the longest word fits within 76% of the word cloud width.
        const maxAllowedWordWidth = width * 0.76;
        if (maxWordWidth > maxAllowedWordWidth) {
            const fontScaleFactor = maxAllowedWordWidth / maxWordWidth;
            fontSizeMultiplyFactor *= fontScaleFactor;
        }

        // Calculate height based on top 5 font sizes.
        let heightFactor = minFontSize + fontSizeMultiplyFactor * (highestWordCount - 1);
        for (let i = 1; i < 5; i++) {
            if (words[i]) {
                heightFactor += minFontSize + fontSizeMultiplyFactor * (words[i].count - 1);
            }
        }

        let height;
        if (width <= 332) {
            height = heightFactor * 2;
            height = Math.min(1.778 * width, height);
            height = Math.max(0.5625 * width, height);
        } else {
            height = width * 0.5625; // Default to 16:9 aspect ratio
        }

        if (wordCloud.closest('.fullscreen').length > 0) {
            // Word cloud is draw in fullscreen mode, limit the height to the viewport height minus footer height.
            const maxHeight = window.innerHeight - wordCloud.find('.wordcloud-footer').height();
            height = Math.min(height, maxHeight);
        }

        const aiFullScreenModal = wordCloud.closest('.ai-full-screen-modal');
        if (aiFullScreenModal.length > 0) {
            // Word cloud is draw in AI fullscreen modal, limit the height.
            const modalBody = aiFullScreenModal.find('.modal-body');
            const verticalPadding = parseInt(modalBody.css('padding-top')) + parseInt(modalBody.css('padding-bottom'));
            const maxHeight = aiFullScreenModal.find('.loader-wrapper').height() - verticalPadding - wordCloud.find('.wordcloud-footer').height();
            height = Math.min(height, maxHeight);
        }

        return height;
    };

    const animateWords = function (wordCloud, cloud) {
        const update = wordCloud.hasClass('update-words');
        let timeout = 0;

        cloud.find('text').each(function () {
            const text = $(this);
            timeout += 20;

            // Store the original font size before starting animation.
            const originalFontSize = text.css('font-size');

            // Set opacity to zero immediately without animation.
            wordCloud.addClass('no-transition');
            text.css('opacity', 0);

            if (!update) {
                // When drawing the word cloud for the first time, set font size to zero without animation.
                text.css('font-size', '0px');
            }

            // Set an incremental timeout to show the words.
            setTimeout(function () {
                // Remove the no-transition class to allow for animation.
                wordCloud.removeClass('no-transition');

                // Animate opacity to fully visible.
                text.css('opacity', 1);

                if (!update) {
                    // When drawing for the first time, we animate words from zero to original size.
                    text.css('font-size', originalFontSize);
                    return;
                }

                // When updating, we pulse the word sizes (reduce 5 pixels and then restore to original).
                text.css('font-size', (parseFloat(originalFontSize) - 5) + 'px');
                setTimeout(() => {
                    text.css('font-size', originalFontSize);
                }, 300);
            }, timeout);
        });
    };

    return {
        init: (elem) => {
            elem.findIncludingSelf('.howspace-wordcloud:not(.howspace-wordcloud-initialized)').each(function () {

                const wordCloud = $(this);
                wordCloud.addClass('howspace-wordcloud-initialized');

                wordCloud.on('click', '.wordcloud-cloud text[data-summary]', function () {
                    const title = this.textContent.trim();
                    const summaryHtml = `
                        <div class="howspace-summary">
                            <div class="summary-content">
                                <div class="summary-text" style="margin: 6%;">${this.dataset.summary}</div>
                                <div class="summary-footer" style="text-align: left;">${howspace.translate('wordcloud_summary_footer')}</div>
                            </div>
                        </div>
                    `;
                    howspace.components.modal.show($('#plain-text-modal'), modal => {
                        $(modal).find('.modal-title').text(title);
                        $(modal).find('.modal-body')
                            .addClass('pt-0')
                            .html(DOMPurify.sanitize(summaryHtml));
                    });
                });

                const content = wordCloud.find('.wordcloud-content');
                if (content.is(':visible')) {
                    if (
                        howspace.components.translator.isEnabled() &&
                        howspace.components.translator.getTargetLang() !== null &&
                        wordCloud.hasClass('translatable-attr')
                    ) {
                        redrawWordCloudAsTranslatorCallback(wordCloud);
                        howspace.components.translator.init(wordCloud);
                    } else {
                        redrawWordCloud(wordCloud);
                    }
                }
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-wordcloud-initialized').each(function () {
                const wordCloud = $(this);
                const cloud = wordCloud.find('.wordcloud-cloud');
                if (cloud.hasClass('observing-resize')) {
                    cloud.removeClass('observing-resize');
                    cloud.removeDataAndAttr('latest-width');
                    cloud.removeDataAndAttr('latest-height');
                    resizeObserver.unobserve(cloud[0]);
                }
            });
        },
        update: (wordCloud, items, isError = false) => {
            const loader = wordCloud.find('.howspace-loader');
            const noContent = wordCloud.find('.wordcloud-no-content');
            const content = wordCloud.find('.wordcloud-content');

            if (isError && items !== '') {
                noContent.html('<div class="alert alert-warning">' + DOMPurify.sanitize(items) + '</div>');
            } else if (!isError && items.length === 0) {
                // Blank state: empty or not enough source content to generate from.
                noContent.text(howspace.translate('wordcloud_no_items'));
            }

            wordCloud.dataAndAttr('items', items);
            if (isError || items.length === 0) {
                // No items, show no content / error message.
                loader.hide();
                noContent.show();
                content.hide();
            } else if (
                howspace.components.translator.isEnabled() &&
                howspace.components.translator.getTargetLang() !== null &&
                wordCloud.hasClass('translatable-attr')
            ) {
                // Translate the content before redrawing the word cloud.
                redrawWordCloudAsTranslatorCallback(wordCloud);
                howspace.components.translator.init(wordCloud);
            } else {
                // No translation needed, just redraw the word cloud.
                loader.hide();
                noContent.hide();
                content.show();
                redrawWordCloud(wordCloud);
            }
        }
    };
})();
